import * as React from 'react';
import {ChevronSmallDownIcon, ChevronSmallUpIcon} from '../../../../icons';
import {NumberInputButton} from '../../NumberInputButton';
import {BUTTON_POSITIONS, STEP_DIRECTIONS} from '../../_constants';
import {StepDirection} from '../../_types';
import {
  ControlsDivider,
  NumberInputTrailingControlsView,
} from './NumberInputTrailingControls.style';

type NumberInputTrailingControlsProps = {
  isDisabled?: boolean;
  isError?: boolean;
  isFocused?: boolean;
  isMax?: boolean;
  isMin?: boolean;
  onStepClick: (direction: StepDirection, isSkip: boolean) => void;
  shouldShowTrailingControls?: boolean;
};

export const NumberInputTrailingControls = React.memo(
  ({
    isDisabled,
    isError,
    isFocused,
    isMax,
    isMin,
    onStepClick,
    shouldShowTrailingControls,
  }: NumberInputTrailingControlsProps) => {
    const handleStepClick = React.useCallback(
      (direction: StepDirection, isSkip: boolean) => {
        onStepClick(direction, isSkip);
      },
      [onStepClick]
    );

    if (!shouldShowTrailingControls) return null;

    return (
      <NumberInputTrailingControlsView
        isDisabled={isDisabled}
        isError={isError}
        isFocused={isFocused}
        spacing={0}
      >
        <NumberInputButton
          Icon={ChevronSmallUpIcon}
          iconProps={{size: 14}}
          isDisabled={isDisabled}
          isMax={isMax}
          onClick={handleStepClick}
          position={BUTTON_POSITIONS.TOP}
          stepDirection={STEP_DIRECTIONS.UP}
        />
        <ControlsDivider elevation={1} />
        <NumberInputButton
          Icon={ChevronSmallDownIcon}
          iconProps={{size: 14}}
          isDisabled={isDisabled}
          isMin={isMin}
          onClick={handleStepClick}
          position={BUTTON_POSITIONS.BOTTOM}
          stepDirection={STEP_DIRECTIONS.DOWN}
        />
      </NumberInputTrailingControlsView>
    );
  }
);
